export default "__VITE_ASSET__9dec87c1__"